<app-layout [isProducerArea]="true">
  <app-page-header
    [title]="'Meus cartões'"
    [titleIcon]="'pi pi-credit-card'"
    [subtitle]="'Gerencie os cartões salvos na sua conta.'"
    [breadcrumbs]="[
      { label: 'Início', link: '/', icon: 'pi pi-home' },
      { label: 'Meus cartões', icon: 'pi pi-credit-card' },
    ]">
  </app-page-header>

  <section class="manage-cards">
    <div class="manage-cards__list-header">
      <app-button type="button" icon="pi pi-plus" (btnClick)="handleAddNewCardClick()">
        Adicionar novo cartão
      </app-button>
    </div>

    @if (loading) {
      <p class="manage-cards__empty">Carregando cartões...</p>
    } @else if (savedCards.length === 0) {
      <div class="manage-cards__empty">
        <i class="pi pi-credit-card manage-cards__empty-icon"></i>
        <p>Você ainda não tem cartões salvos.</p>
        <p class="manage-cards__empty-hint">Adicione um cartão para agilizar suas próximas compras.</p>
      </div>
    } @else {
      <app-credit-card-wallet
        [savedCards]="savedCards"
        [showSelection]="false"
        [showDelete]="true"
        [title]="''"
        (deleteCard)="handleDeleteCard($event)" />
    }
  </section>
</app-layout>
